import { WebinarStatus } from '@core/types';
import { Trans } from 'react-i18next';

export const WebinarStatusMessage = ({ hasBooking, status }: { hasBooking: boolean; status: number }) => (
    <p className="-mt-2 mb-4">
        {!hasBooking && status === WebinarStatus.Planned && (
            <Trans components={{ span: <span className="font-medium" /> }} i18nKey="Webinar.StatusMessage.Timeslot" />
        )}
        {status === WebinarStatus.Cancelled && (
            <Trans components={{ span: <span className="font-medium" /> }} i18nKey="Webinar.StatusMessage.Cancelled" />
        )}
        {status === WebinarStatus.Expired && (
            <Trans components={{ span: <span className="font-medium" /> }} i18nKey="Webinar.StatusMessage.Expired" />
        )}
    </p>
);
